import { useQuery } from '@tanstack/react-query';
import apiClient from 'api/apiConfig';
import { ServerModule } from '../ServerWorkflowType';

const modulesUrl = '/csb/modules';

const fetchModules = async (): Promise<ServerModule[]> => {
  const response = await apiClient.get<ServerModule[]>(modulesUrl);
  return response.data;
};

export const useModulesQuery = () =>
  useQuery<ServerModule[]>({
    queryFn: fetchModules,
    queryKey: ['modules'],
  });
